import { BaseWizardStep } from '../base.wizard.step';

import { ApiService } from '@nrwl/common-lib';

export class DatasourceWizardStep extends BaseWizardStep {
  addNewItemCallback: any;
  methodTypeSource: any;
  selectedMethod: any;
  gigaStorData: any;
  selectedDataSource: any;
  dataSourceSelected = false;
  constructor(apiService: ApiService, config: any, parent: any) {
    super(apiService, config, parent);

    if (this.config.def.subContent) {
      this.subContent = new DatasourceWizardStep(
        apiService,
        config.def.subContent,
        this
      );
    }
  }

  _reqResOnSuccessful(response) {
    this.parent.onAgentWizardSuccess(response.success.agent);
  }

  makeValueForAgentProxy(componentId, key, newValue, isValid) {
    if (
      newValue.config &&
      !newValue.config.useDefault &&
      newValue.config.protocol
    ) {
      const proxyConfig: any = {};
      proxyConfig.protocol = newValue.config.protocol;
      proxyConfig.address = newValue.config.address;
      proxyConfig.port = newValue.config.port;
      this.dataValueChange(componentId, key, proxyConfig, isValid);
    } else {
      this.dataValueChange(componentId, key, null, isValid);
    }
  }
}
